export default "__VITE_ASSET__DKcFY99o__"